import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabaseStorageBucket = import.meta.env.VITE_SUPABASE_STORAGE_BUCKET ?? "shyne-bucket";
const supabase = createClient(supabaseUrl, supabaseKey);

export const SUPABASE_STORAGE_BUCKET = supabaseStorageBucket;

export default supabase;
